import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'trackify-user-monthly-status',
  templateUrl: './user-monthly-status.component.html',
  styleUrls: ['./user-monthly-status.component.scss']
})
export class UserMonthlyStatusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
